import { render, staticRenderFns } from "./tire-scheme.vue?vue&type=template&id=61b34c76&scoped=true&"
import script from "./tire-scheme.vue?vue&type=script&lang=ts&"
export * from "./tire-scheme.vue?vue&type=script&lang=ts&"
import style0 from "./tire-scheme.vue?vue&type=style&index=0&id=61b34c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b34c76",
  null
  
)

export default component.exports